import { Outlet } from "react-router";
import "style/discoverPage.css";
import { DiscoverSubheader } from "features/discover/DiscoverSubheader";

export function DiscoverLayoutPage() {
    return (
        <div className="discover-layout">
            <DiscoverSubheader />
			<Outlet />
        </div>
    );
}
